import { Box, Grid, Avatar } from "@mui/material";
// import Sidebar from "./Sidebar";
import TriangleWithLines from "../components/Triangle";
import { DealListTable, LeadsTable } from "../components/Deal";
 
const Dashboard = () => {
  return (
    <Box sx={{ display: "flex",width:"80%",marginLeft:"10%" }}>
      <Box sx={{ flexGrow: 1, padding: 4 }}>
        <Grid container spacing={4}>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
          </Grid>
          <Grid item xs={12}>
            <TriangleWithLines />
          </Grid>
          <Grid item xs={12}>
            <LeadsTable />
          </Grid>
          <Grid item xs={12}>
            <DealListTable />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
 
export default Dashboard;
 